import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterListAutosizerWrapper = styled<any, any>(
    'div',
    'filterListAutosizerWrapper',
    'filterItemDropdown'
)`
    ${propStyles};
`;

FilterListAutosizerWrapper.defaultProps = {
    height: '300px',
};

export default FilterListAutosizerWrapper;



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/StyledComponents/FilterListAutosizerWrapper.tsx